export default __webpack_public_path__ + "static/about-5-14320bf12b7f9e43b08a303fe565bccc.png";